import React from 'react';
import {Input} from 'reactstrap';

const TextInput = React.forwardRef((props, ref) => {
  let formControl = 'form-control';
  let errorMsg = '';
  //const textInputRef = useRef();

  if (props.error && props.error.length > 0) {
    formControl = 'input-error';
    errorMsg = props.error;
  }

  return (
    <label className={`has-float-${props.required ? 'label-required' : 'label'}`}>
      <Input disabled={props.disabled} ref={ref} name={props.name} className={formControl} {...props} />
      <span className={`${props.error && props.error.length > 0 ? 'placeholder-error' : ''}`}>{props.placeholder}</span>
      {errorMsg.length > 0}
      {errorMsg.length > 0 && <div className='error'>{errorMsg}</div>}
    </label>
  );
});

export default TextInput;
